'use client';

import { memo } from 'react';

import { config } from '@air/api';
import { configureAPIPackage } from '@air/utils-auth';
import { initializeBugsnag } from '@air/utils-error';

import { ENV } from '~/constants/Env';
import { openInNewWindowUrlOpener } from '~/utils/urlOpeners';

const appVersion = process.env.APP_VERSION || '';

if ((typeof window !== 'undefined' && window.top !== window.self) || ENV.API_IN_BROWSER) {
  configureAPIPackage({
    oauthConfigParams: {
      redirectSignIn: process.env.NEXT_PUBLIC_OAUTH_SIGNIN_REDIRECT,
      redirectSignOut: process.env.NEXT_PUBLIC_OAUTH_SIGNOUT_REDIRECT,
      urlOpener: openInNewWindowUrlOpener,
    },
  });
}

config.setClientVersion('ShopifyPlugin', appVersion);

initializeBugsnag({
  apiKey: process.env.NEXT_PUBLIC_BUGSNAG ?? '',
  appVersion,
  releaseStage: process.env.NEXT_PUBLIC_VERCEL_ENV ?? '',
});

export const AppInitializer = memo(() => {
  return null;
});

AppInitializer.displayName = 'AppInitializer';
